import React from 'react';

export default props => (
  <section className='content'>{props.children}</section>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/content/Content.jsx